import React from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";

import PrepaymentForm from "./PrepaymentForm";
import AnalysisResult from "./AnalysisResult";

const FormWrapper = styled(Grid)`
  height:100%;
  
`;
const ResultWrapper = styled(Grid)`  
  &&&& {
    max-width: 100%;
  }
`;

class PrepaymentCalculatorPage extends React.Component {
  state = {
    prepaymentParameters: null
  };

  setParams = (params) => {
    this.setState({ prepaymentParameters: params });
  };
  render() {
    return (
      <Grid container justify="space-between" spacing={24}>
        <FormWrapper item xs={5} lg={7} style={{ marginBottom: "20px" }}>
          <PrepaymentForm moveToAnalysisResult={this.setParams} />
        </FormWrapper>
        <ResultWrapper item xs={6} lg={4}>
          <AnalysisResult prepaymentParameters={this.state.prepaymentParameters} />
        </ResultWrapper>
        <div item lg={1} />
      </Grid>
    );
  }
}
export default PrepaymentCalculatorPage;
